import LabelsContainer from './labels-container';

export default LabelsContainer;
